import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { map, share, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NotificationService } from '../feature-modules/admin/service/notification.service';
import { _throw } from 'rxjs/observable/throw';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EncriptDecriptService } from './encriptdecript';

@Injectable()
export class UserService {

  constructor(private Http: HttpClient, private router: Router,
    public activeModal: NgbActiveModal,
    private encriptDecriptService: EncriptDecriptService,
    private notificationService: NotificationService) { }

  protected standardHeaders() {
    return {
      'Content-Type': 'application/json',
      'token': this.encriptDecriptService.getKeyLocalStorage('token')
    };
  }

  goToLoginPage() {
    this.activeModal.close();
    this.router.navigate(['/login']);
    localStorage.clear();
    sessionStorage.clear();
    this.notificationService.sessionExpaireNotification();
  }

  // get user assigned categories on dashboards
  // tslint:disable:max-line-length
  getusercourse(data, start, searchType): Observable<any> {
    const url = environment.api_url1 + '/userAssignedCategoryPagination/list?start=' + start + '&limit=' + 15 + '&searchType=' + searchType;
    return this.Http.post(url,
      data, {
      headers: this.standardHeaders()

    })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );

  }
  // user course inprogress API
  getInprogressCourseForUser(data, start, searchType): Observable<any> {
    const url = environment.api_url1 + '/userAssignedCategoryPagination/list?start=' + start + '&limit=' + 15 + '&searchType=' + searchType;
    return this.Http.post(url,
      data, {
      headers: this.standardHeaders()

    }).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(error => {
        if (error.status == 401) { this.goToLoginPage(); }
        return _throw(error);
      })
    );
  }
  // user coure completed API
  getCompletdCourseForUser(data, start, searchType): Observable<any> {
    const url = environment.api_url1 + '/userAssignedCategoryPagination/list?start=' + 0 + '&limit=' + 15 + '&searchType=' + searchType;
    return this.Http.post(url,
      data, {
      headers: this.standardHeaders()
    })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );
  }

  // gatlogin userObjects on user to store localstorage
  getUserObj(user: any): Observable<any> {
    return this.Http.post(environment.api_url + '/user/login', user, {
      headers: { 'Content-Type': 'application/json' }
    })

  }

  // login API
  login(user: any): Observable<any> {
    return this.Http.post(environment.api_url + '/user/login', user, {
      headers: { 'Content-Type': 'application/json' }
    });
  }

  // change User password
  changePassword(user: any, newpassword: string): Observable<any> {
    return this.Http.post(environment.api_url + '/user/resetPassword?newPassword=' + newpassword, user, {
      headers: this.standardHeaders()
    });
  }

  public getLearnerReport(userobj: any): Observable<any> {
    // console.log(userobj);

    return this.Http.post(environment.api_url1
      + '/category/userAnalytics', userobj,
      { headers: this.standardHeaders() })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );
  }
  // category Launch API method
  categoryLaunchPath(userobj: any, categoryId: any): Observable<any> {
    return this.Http.post(environment.api_url1
      + '/category/launch?categoryId=' + categoryId, userobj,
      { headers: this.standardHeaders() })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );

  }

  // section Launch API method
  getVideoPath(id, user): Observable<any> {
    return this.Http.post(environment.api_url1
      + '/lesson/launch?lessonId=' + id, user,
      { headers: this.standardHeaders() })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );

  }


  checkIsLessonCompleted(lessonId: any, userObject: Object): Observable<any> {
    return this.Http.post(environment.api_urlFor_tocheck_statusof_lesson + '/lesson/isCompleted?lessonId=' + lessonId,
      userObject, { headers: this.standardHeaders() })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );
  }


  getCategoryTreeObject(categoryid, user, courseLock) {
    if (categoryid) {
      return this.Http.post(environment.api_url1 + '/treeStructure/category/' +
        categoryid + '/isCourseLock/' + courseLock, user,
        { headers: this.standardHeaders() })
        .pipe(
          map((response: any) => {
            return response;
          }),
          catchError(error => {
            if (error.status == 401) { this.goToLoginPage(); }
            return _throw(error);
          })
        );
    }
  }

  /**
   * @description - Method to get the Course Topics and Lessons under the topic of the selected course.
   * @param  categoryid - course id.
   * @param user - User object.
   */
  getCourseList(categoryid, user, courseLock): Observable<any[]> {
    return this.Http.post(environment.api_url1 + '/treeStructure/category/' + categoryid + '/isCourseLock/' + courseLock, user,
      {
        headers: this.standardHeaders(),
        observe: 'response',
        reportProgress: true
      }).pipe(
        map((res: HttpResponse<any>) => {
          if (res.body.Course.Topics) {
            return res.body.Course.Topics;
          }
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );
  }

  getRecentlyCategoryTreeObject(categoryid, user) {

    return this.Http.post(environment.api_url1 + '/treeStructure/lesson/' + categoryid, user,
      { headers: this.standardHeaders() })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );
  }

  getUserTransactionList(organisationId, userId) {

    const RequestBodyObject = {
      'organisationId': organisationId,
      'userId': userId
    };
    return this.Http.post(environment.api_url1 + '/UserTransaction/list', RequestBodyObject,
      { headers: this.standardHeaders() })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );
  }

  getcategoryUserlaunch(recordId, tableName, userObject) {

    return this.Http.post(environment.api_url1 + '/categoryUser/launch?recordId=' + recordId + '&tableName=' + tableName, userObject,
      { headers: this.standardHeaders() })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );
  }

  getUserParam(lessonId): Observable<any> {
    const RequestBodyObejct = { 'lessonId': lessonId };
    return this.Http.post(environment.api_url1 + '/lesson/params', RequestBodyObejct,
      { headers: this.standardHeaders() })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );
  }

  // get user profile API 6:10:2018
  getProfileObject(userId: any): Observable<any> {
    return this.Http.post(environment.api_url + '/user/params',
      { 'userId': userId },
      { headers: this.standardHeaders() })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );
  }


  //  Create user API
  saveUser(data: any, orgName: any) {

    return this.Http.post(environment.api_url + '/user/' + orgName, data,
      { headers: this.standardHeaders() })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );


  }

  SaveBookMarkServ(RequestObject) {
    return this.Http.post(environment.api_url1 + '/saveBookMark', RequestObject,
      { headers: this.standardHeaders() }).pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );
  }

  getBookMarkListServ(RequestObject) {
    return this.Http.post(environment.api_url1 + '/bookMarkedCategory/list', RequestObject,
      { headers: this.standardHeaders() })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );
  }

  getRecentlyBookMarkedObject(userId, orgId): Observable<any> {
    return this.Http.get(environment.api_url1 + '/recentBookMarkAndSizeOfList/' + userId + '/' + orgId,
      { headers: this.standardHeaders() })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );
  }


  //  token validation for set password in user Email
  checkValidityOfToken(token: any): Observable<any> {
    return this.Http.get(environment.api_url + '/user/checkToken?token=' + token, {
      headers: { 'Content-Type': 'application/json' }
    });
  }
  // set password API
  UpdatePassword(user, token) {
    return this.Http.post(environment.api_url + '/user/setPassword?token=' + token, user, {
      headers: { 'Content-Type': 'application/json' }
    })
  }

  // forget  password API
  checkMailValidator(emailId: any): Observable<any> {
    return this.Http.get(environment.api_url + '/user/forgotPasswordEmail?emailId=' + emailId, {
      headers: { 'Content-Type': 'application/json' }
    })
  }


  public getuseranalytic(userObj: any): Observable<any> {
    return this.Http.post(environment.api_url1 + '/category/userAnalytics', userObj,
      { headers: this.standardHeaders() })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );
  }

  // login API
  logOut(userId: any): Observable<any> {
    return this.Http.delete(environment.api_url + '/userSession?userId=' + userId, {
      headers: { 'token': this.encriptDecriptService.getKeyLocalStorage('token') }
    }).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(error => {
        if (error.status == 401) { this.goToLoginPage(); }
        return _throw(error);
      })
    );
  }

  public getQuizReviewFromMail(userId, lessonId): Observable<any> {
    return this.Http.get(environment.api_url1 + '/category/user/' + userId + '/lesson/' + lessonId,
    {
      headers: { 'Content-Type': 'application/json' }
    }).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(error => {
        if (error.status == 401) { this.goToLoginPage(); }
        return _throw(error);
      })
    );
  }

  public categoryListForTestCandidate(orgId): Observable<any> {
    let url: string = environment.api_url1 + '/category/Catlog';
    if (orgId !== '') {
      url = url + `?organisationId=${orgId}`
    }
    return this.Http.get(url,
      { headers: { 'Content-Type': 'application/json' } })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );
  }

  // to create testcandidates 
  saveTestUser(userObject: object, categoryId: any): Observable<any> {
    return this.Http.post(environment.api_url + '/user/testCandidate?categoryIds=' + categoryId,
      userObject, {
      headers: { 'Content-Type': 'application/json' }
    }).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(error => {
        if (error.status == 401) { this.goToLoginPage(); }
        return _throw(error);
      })
    );
  }

  // To send testcandidate quiz report 
  sendQuizReport(userObject: object): Observable<any> {

    return this.Http.post(environment.api_url1 + '/sendQuizReport',
      userObject, {
      headers: this.standardHeaders()
    }).pipe(
      map((response: any) => {
        return response;
      }),
      catchError(error => {
        if (error.status == 401) { this.goToLoginPage(); }
        return _throw(error);
      })
    );
  }

  // To send testcandidate quiz report 
  loginAkku(userEmail: object): Observable<any> {

    return this.Http.get(environment.api_url + '/user/akkuUser?userEmailId=' + userEmail)
  }

  // get user profile API 09:12:2020
  getuserObjectById(userId: any, token: any): Observable<any> {
    return this.Http.post(environment.api_url + '/user/params',
      { 'userId': userId },
      {
        headers: {
          'Content-Type': 'application/json',
          'token': token
        }
      })
    // .pipe(
    //   map((response: any) => {
    //     return response;
    //   }),
    //   catchError(error => {
    //     if (error.status == 401) { this.goToLoginPage(); }
    //     return _throw(error);
    //   })
    // );
  }

}


// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/services/user.service.ts